import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CheckIcon from '@mui/icons-material/Check';
import FormDialog from "../FormDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

const ConfirmModal = ({title, onConfirm, onClose, open, mainTitle, ...rest}) => {

    const [loading, setLoading] = useState(false);

    const handleConfirm = useCallback(async () => {
        setLoading(true)
        await onConfirm()
        setLoading(false)
    }, [onConfirm]);

    return (
        <FormDialog title={mainTitle || 'Confirm Action'} {...rest} onClose={onClose} open={open}>
            <DialogContent dividers>
                <Backdrop
                    sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                    open={loading}
                >
                    <CircularProgress color="inherit"/>
                </Backdrop>
                <Typography>{title}</Typography>
            </DialogContent>
            <DialogActions>
                <Button color="error" variant={"contained"} startIcon={<CheckIcon/>}
                        onClick={handleConfirm}>Accept</Button>
            </DialogActions>
        </FormDialog>
    );
};

ConfirmModal.propTypes = {
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

ConfirmModal.defaultProps = {
    title: "Are you sure?"
};

export default ConfirmModal;
